<!-- ----------------------------------------------- -->
<template>
  <v-card id="info-dialog" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header pa-0">
      <span class="com-mb-dialog-title">お知らせ検索・検索一覧</span>
      <v-spacer></v-spacer>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents pa-0">
      <v-col class="if-srch-card">
        <if-search></if-search>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 お知らせ検索
 * Info.vue
 * @author LIS
 */

import mixin from "./../../../lib/mixin.js";
/** お知らせ検索・検索結果一覧カード */
import IfSearch from "../../../components/mb/IfSearch.vue";

export default {
  name: "mb-info",
  mixins: [mixin],
  components: {
    IfSearch
  },
  mounted() {
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "info");
  },
  methods: {
    closeDlg() {
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}
#info-dialog {
  right: 4px;
  overflow: hidden;
}
.fnt-size {
  font-size: 0.65rem;
}
.if-srch-card {
  display: flex;
  border: solid 1px #ddd;
  height: 100%;
  padding: 0;
}
</style>
